/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as AuthenticatedRouteImport } from './routes/_authenticated'
import { Route as SignInRouteImport } from './routes/sign-in'
import { Route as AuthenticatedIndexRouteImport } from './routes/_authenticated/index'
import { Route as AuthenticatedCampaignsIndexRouteImport } from './routes/_authenticated/campaigns.index'
import { Route as AuthenticatedCompaniesIndexRouteImport } from './routes/_authenticated/companies.index'
import { Route as AuthenticatedCompaniesCompany_idRouteImport } from './routes/_authenticated/companies.$company_id'
import { Route as AuthenticatedInsightsIndexRouteImport } from './routes/_authenticated/insights.index'

const AuthenticatedRoute = AuthenticatedRouteImport.update({
  id: '/_authenticated',
  getParentRoute: () => rootRouteImport,
} as any)
const SignInRoute = SignInRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthenticatedIndexRoute = AuthenticatedIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AuthenticatedRoute,
} as any)
const AuthenticatedCampaignsIndexRoute =
  AuthenticatedCampaignsIndexRouteImport.update({
    id: '/campaigns/',
    path: '/campaigns/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCompaniesIndexRoute =
  AuthenticatedCompaniesIndexRouteImport.update({
    id: '/companies/',
    path: '/companies/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedCompaniesCompany_idRoute =
  AuthenticatedCompaniesCompany_idRouteImport.update({
    id: '/companies/$company_id',
    path: '/companies/$company_id',
    getParentRoute: () => AuthenticatedRoute,
  } as any)
const AuthenticatedInsightsIndexRoute =
  AuthenticatedInsightsIndexRouteImport.update({
    id: '/insights/',
    path: '/insights/',
    getParentRoute: () => AuthenticatedRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof AuthenticatedIndexRoute
  '/sign-in': typeof SignInRoute
  '/companies/$company_id': typeof AuthenticatedCompaniesCompany_idRoute
  '/campaigns/': typeof AuthenticatedCampaignsIndexRoute
  '/companies/': typeof AuthenticatedCompaniesIndexRoute
  '/insights/': typeof AuthenticatedInsightsIndexRoute
}
export interface FileRoutesByTo {
  '/sign-in': typeof SignInRoute
  '/': typeof AuthenticatedIndexRoute
  '/companies/$company_id': typeof AuthenticatedCompaniesCompany_idRoute
  '/campaigns': typeof AuthenticatedCampaignsIndexRoute
  '/companies': typeof AuthenticatedCompaniesIndexRoute
  '/insights': typeof AuthenticatedInsightsIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/_authenticated': typeof AuthenticatedRouteWithChildren
  '/sign-in': typeof SignInRoute
  '/_authenticated/': typeof AuthenticatedIndexRoute
  '/_authenticated/companies/$company_id': typeof AuthenticatedCompaniesCompany_idRoute
  '/_authenticated/campaigns/': typeof AuthenticatedCampaignsIndexRoute
  '/_authenticated/companies/': typeof AuthenticatedCompaniesIndexRoute
  '/_authenticated/insights/': typeof AuthenticatedInsightsIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/sign-in'
    | '/companies/$company_id'
    | '/campaigns/'
    | '/companies/'
    | '/insights/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/sign-in'
    | '/'
    | '/companies/$company_id'
    | '/campaigns'
    | '/companies'
    | '/insights'
  id:
    | '__root__'
    | '/_authenticated'
    | '/sign-in'
    | '/_authenticated/'
    | '/_authenticated/companies/$company_id'
    | '/_authenticated/campaigns/'
    | '/_authenticated/companies/'
    | '/_authenticated/insights/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  AuthenticatedRoute: typeof AuthenticatedRouteWithChildren
  SignInRoute: typeof SignInRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/_authenticated': {
      id: '/_authenticated'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sign-in': {
      id: '/sign-in'
      path: '/sign-in'
      fullPath: '/sign-in'
      preLoaderRoute: typeof SignInRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_authenticated/': {
      id: '/_authenticated/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof AuthenticatedIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/campaigns/': {
      id: '/_authenticated/campaigns/'
      path: '/campaigns'
      fullPath: '/campaigns/'
      preLoaderRoute: typeof AuthenticatedCampaignsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/companies/': {
      id: '/_authenticated/companies/'
      path: '/companies'
      fullPath: '/companies/'
      preLoaderRoute: typeof AuthenticatedCompaniesIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/companies/$company_id': {
      id: '/_authenticated/companies/$company_id'
      path: '/companies/$company_id'
      fullPath: '/companies/$company_id'
      preLoaderRoute: typeof AuthenticatedCompaniesCompany_idRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
    '/_authenticated/insights/': {
      id: '/_authenticated/insights/'
      path: '/insights'
      fullPath: '/insights/'
      preLoaderRoute: typeof AuthenticatedInsightsIndexRouteImport
      parentRoute: typeof AuthenticatedRoute
    }
  }
}

interface AuthenticatedRouteChildren {
  AuthenticatedIndexRoute: typeof AuthenticatedIndexRoute
  AuthenticatedCompaniesCompany_idRoute: typeof AuthenticatedCompaniesCompany_idRoute
  AuthenticatedCampaignsIndexRoute: typeof AuthenticatedCampaignsIndexRoute
  AuthenticatedCompaniesIndexRoute: typeof AuthenticatedCompaniesIndexRoute
  AuthenticatedInsightsIndexRoute: typeof AuthenticatedInsightsIndexRoute
}

const AuthenticatedRouteChildren: AuthenticatedRouteChildren = {
  AuthenticatedIndexRoute: AuthenticatedIndexRoute,
  AuthenticatedCompaniesCompany_idRoute: AuthenticatedCompaniesCompany_idRoute,
  AuthenticatedCampaignsIndexRoute: AuthenticatedCampaignsIndexRoute,
  AuthenticatedCompaniesIndexRoute: AuthenticatedCompaniesIndexRoute,
  AuthenticatedInsightsIndexRoute: AuthenticatedInsightsIndexRoute,
}

const AuthenticatedRouteWithChildren = AuthenticatedRoute._addFileChildren(
  AuthenticatedRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  AuthenticatedRoute: AuthenticatedRouteWithChildren,
  SignInRoute: SignInRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
